(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const mounted = new Map();
  const enhance = root => {
    if (mounted.has(root)) return;
    const track = root.querySelector('.review-grid, .cr-track');
    if (!track) return;
    const cards = [...track.children].filter(el => el.matches('article'));
    if (!cards.length) return;
    const abort = new AbortController();
    const options = {signal: abort.signal};
    const oldTabIndex = track.getAttribute('tabindex');
    const originalIndex = root.index;
    const originalLeft = track.scrollLeft;
    let index = 0;
    let timer;
    root.classList.add('mobile-cards');
    track.tabIndex = 0;
    const controls = document.createElement('div');
    controls.className = 'mobile-card-controls';
    controls.setAttribute('role', 'group');
    const label = root.matches('.comfort-scenarios') ? 'benefit' : 'review';
    controls.setAttribute('aria-label', `Choose a ${label}`);
    const status = document.createElement('span');
    status.className = 'mobile-card-status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    const buttons = cards.map((card, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mobile-card-dot';
      button.setAttribute('aria-label', `Show ${label} ${i + 1}`);
      button.appendChild(document.createElement('span'));
      button.addEventListener('click', () => show(i), options);
      controls.appendChild(button);
      return button;
    });
    controls.appendChild(status);
    root.appendChild(controls);
    const left = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const update = () => {
      buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      status.textContent = `${label === 'benefit' ? 'Benefit' : 'Review'} ${index + 1} of ${cards.length}`;
    };
    function show(next, instant = false) {
      index = Math.max(0, Math.min(next, cards.length - 1));
      // Keep the theme's existing review controller synchronized while on mobile.
      if (typeof root.index === 'number') root.index = index;
      track.scrollTo({left: left(cards[index]), behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      update();
    }
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        index = cards.reduce((best, card, i) => Math.abs(left(card) - track.scrollLeft) < Math.abs(left(cards[best]) - track.scrollLeft) ? i : best, 0);
        update();
      }, 160);
    }, options);
    root.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      show(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    }, {...options, capture: true});
    document.addEventListener('shopify:block:select', event => {
      const card = event.target instanceof Element ? event.target.closest('article') : null;
      const id = String(event.detail?.blockId || '');
      const selected = cards.findIndex(el => el === card || (el.dataset.blockId && (id === el.dataset.blockId || id.endsWith(`__${el.dataset.blockId}`))));
      if (selected >= 0) show(selected, true);
    }, options);
    mounted.set(root, () => {
      abort.abort(); clearTimeout(timer); controls.remove();
      root.classList.remove('mobile-cards');
      if (oldTabIndex === null) track.removeAttribute('tabindex'); else track.setAttribute('tabindex', oldTabIndex);
      if (typeof originalIndex === 'number' && typeof root.show === 'function') root.show(originalIndex, true);
      else track.scrollTo({left: originalLeft, behavior: 'instant'});
    });
    show(0, true);
  };
  const refresh = () => {
    for (const [root, dispose] of mounted) if (!mobile.matches || !root.isConnected) { dispose(); mounted.delete(root); }
    if (mobile.matches) document.querySelectorAll('.comfort-scenarios, .customer-review-slider').forEach(enhance);
  };
  mobile.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
})();
